<template>
<div id="messages-tab" class="container">
    <div class="row" v-if="!loading && !showContacts && !showConversation">
        <div class="col-xs-12 text-center no-contacts">
            <br>
            <span class="iconify icon:mdi:message-bulleted-off"></span><br><br>
            You have no messages.<br><br><br>
        </div>
    </div>

    <div class="row contacts-panel" v-if="!loading && showContacts">
        <div class="col-xs-12">
            <input type="text" class="search" placeholder="Search for conversations">
            <i class="iconify icon:ic:outline-search"></i>
        </div>

        <div class="messages-box-container clearfix">
            <span v-if="!showContacts">You have no messages.</span>
            <div class="messages-box-inner clearfix">
                <div class="contacts-list">
                    <contact v-for="(contact, i) in contacts" :contact="contact" class="col-xs-12 button contact" :key="i"></contact>
                </div>
            </div>
        </div>
    </div>

    <div class="row message-panel" v-if="showConversation">
        <div class="col-xs-12 message-header">
            <div class="button button-center back" @click="back()"><i class="iconify icon:ic:round-keyboard-backspace"></i></div>
            <div class="info">
                <img :src="getContactImage" class="image">
                <div class="name">{{selectedContact.name}}</div>
                <div class="type">{{selectedContact.type}}</div>
            </div>

            <div class="button button-center scroll-top" v-show="isBottom" @click="scrollTop()"><span class="iconify icon:ic:baseline-expand-less"></span></div>
            <div class="button button-center scroll-bottom" v-show="!isBottom" @click="scrollBottom()"><span class="iconify icon:ic:baseline-expand-more"></span></div>

            <div class="button button-center more"><span class="iconify icon:ic:baseline-more-horiz"></span></div>
            <div class="clearfix"></div>
        </div>

        <div class="col-xs-12 messages-list">
            <div class="message col-xs-12 text-center">
                <loader color="ripple" size="100px" v-if="!allMessagesLoaded"></loader>
                <h6 v-if="allMessagesLoaded" style="margin: 50px 0px;">ALL MESSAGES LOADED</h6>
            </div>

            <div v-for="(message, i) in messages" class="col-xs-12 message" :class="message.class" v-if="messages.length" @click="resendMessage(message)">
                <div class="date" v-if="message.showDate">
                    <span>{{ message.showDate }}</span>
                </div>

                <div class="profile" :style="{'background-image': 'url('+ message.sender.image +')'}"></div>
                <div class="textbox">
                    <div class="message-body" v-html="message.text"></div>
                    <span v-if="message.status != 'error'" v-html="formatTime(message)"></span>
                    <span v-else>MESSAGE NOT SENT! Tap to retry</span>
                </div>
            </div>
        </div>

        <div class="col-xs-12 message-input">
            <input type="text" id="message-box" class="browser-default" @keyup.enter="submitMessage">
            <span v-show="!showKeyboard" style="pointer-events: none;">
                <i class="iconify icon:ic:baseline-textsms"></i>
            </span>
            <span v-show="showKeyboard" style="pointer-events: none;">
                <i class="iconify icon:ion:send-sharp"></i>
            </span>
        </div>
    </div>

    <div class="row text-center" v-if="loading">
        <loader color="ripple" size="120px" style="min-height: 567px;"></loader>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'contact': require('@/components/Song/Show/Tab/Messages/Contact.vue').default,
        'compose': require('@/components/Song/Show/Tab/Messages/Compose.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['song'],

    data() {
        return {
            contacts: [],
            loading: true,
            allMessagesLoaded: false,
            loadingMessages: false,
            initialHeight: 0,
            search: null,
            selectedContact: null,
            messages: [],
            pageSize: 20,
            page: 0,
            isBottom: false,
            isTop: false,
            showKeyboard: false
        }
    },

    activated(){
        $(document).on('focusin', () => {
            this.showKeyboard = true;

            if (App.platform == 'ios'){
                var navInterval = setInterval( () => {
                    if ( $(window).scrollTop() ){
                        $('.messages-list').css('height', $(window).height() - $(window).scrollTop() - 206);
                        $('.messages-list').scrollTop( $('.messages-list')[0].scrollHeight );
                        clearInterval(navInterval);
                    }
                }, 10);
            }else{
                this.scrollBottom(false, 500);
                this.scrollBottom('.messages-list', 500);
            }
        }).on('focusout', () => {
            this.showKeyboard = false;
            this.scrollBottom();

            if (App.platform == 'ios'){
                $('.messages-list').removeAttr('style');
            }
        });
    },

    mounted() {
        this.getContacts();

        var scrollElem =  $('#musicplayer').is('.maximized') ? '#musicplayer' : 'main';
        $(scrollElem).on("scroll", () => {
            this.isBottom = $(scrollElem)[0].scrollHeight <= $(scrollElem).innerHeight() + $(scrollElem).scrollTop();
            this.isTop = $(scrollElem).scrollTop() == 0;
        });
        
        $('body').on('touchstart', '#message-box', (e) => {
            if ($('#message-box').innerWidth() - ((e.touches[0].clientX || e.touches[0].pageX) - $('#message-box')[0].getBoundingClientRect().left) < 40){
                this.submitMessage();
            }
        });        
    },

    methods: {
        getContacts() {
            this.$http.get(this.getContactsEndpoint).then((success) => {
                this.contacts = success.data.data;
                this.loading = false;
            });
        },

        getMessages(preppend = false){
            this.page++;
            var lastScrollPosition = $('.messages-list')[0] ? $('.messages-list')[0].scrollHeight : 0;

            this.$http.get(this.getMessagesEndpoint).then((success) => {
                var newMessages = success.data.data.messages;
                this.messages = newMessages.reverse().concat(this.messages);
                this.allMessagesLoaded = newMessages.length < this.pageSize;
                

                if (preppend == false && this.selectedContact.unread){
                    this.$root.$emit('messages-badges', {action: 'get'});
                    this.selectedContact.unread = 0;
                    this.song.unread = this.song.unread - this.selectedContact.unread;
                }

                this.$nextTick(() => {
                    $('.messages-list').scrollTop( $('.messages-list')[0].scrollHeight - lastScrollPosition);
                    setTimeout(() => {
                        this.loadingMessages = false;
                    }, 200);
                });
            });
        },

        submitMessage(){
            var textMessage = $('#message-box').val();
            if (textMessage.length < 1) {
                return;
            }

            navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
            if (navigator.vibrate) {
                navigator.vibrate(100);
            }

            var data = { message: textMessage };
            var uid = moment().valueOf() + Math.random();
            $('#message-box').val('');

            var message = {
                text: data.message,
                sender: {
                    name: App.user.name,
                    image: App.user.profile_image_direct_url ? App.user.profile_image_direct_url : '/img/web/default-avatar.svg',
                },
                created_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                participant_role: 'sender',
                uid: uid,
                status: 'pending',
            }

            this.messages.push(message);
            this.$http.post(this.postMessagesEndpoint, data).then((success) => {
                message.id = success.data.data.message.id;
                this.updateMessageStatus(uid, 'sent');
            }, (err) => {
                this.updateMessageStatus(uid, 'error');
            });

            this.$nextTick(() => {
                this.scrollBottom('.messages-list');
            });

            if (App.allowGtag) gtag('event', `send_message`, {
                'event_category' : 'song',
                'event_label' : `Send message in own Song Page`
            });
        },

        updateMessageStatus(uid, status){
            $.each(this.messages, (i, msg) => {
                if (msg.uid == uid){
                    msg.status = status;

                    var cssClasses = $.grep(msg.class.split(' '), (c) => { return c != 'pending' });
                    cssClasses.push(msg.status);
                    msg.class = cssClasses.join(" ");

                    return false;
                }
            })
        },

        resendMessage(message){
            if (message.status == 'error'){
                message.status = 'pending';

                this.$http.post(this.postMessagesEndpoint, { message: message.text }).then((success) => {
                    message.id = success.data.data.message.id;
                    this.updateMessageStatus(uid, 'sent');
                }, (err) => {
                    this.updateMessageStatus(message.uid, 'error');
                });
            }
        },

        formatTime(msg){
            return moment.utc(msg.created_at, 'YYYYY-MM-DD HH:mm:ss').local().format("HH:mm");
        },

        getParticipantRole(senderId) {
            return senderId === App.user.id ? 'sender' : 'receiver';
        },

        back(){
            if (this.showKeyboard){
                $("#message-box").blur();
                return;
            }

            setTimeout(() => {
                this.selectedContact = null;
                this.messages = [];
                this.loadingMessages = false;
                this.allMessagesLoaded = false;
                this.page = 0;
            }, 250);
        },

        scrollTop(elem = false, scroll = 0, speed = 300){
            if (elem == false){
                elem = $('#musicplayer').is('.maximized') ? '#musicplayer' : 'main';
            }

            $(elem).animate({ scrollTop: scroll}, speed);
        },

        scrollBottom(elem = false, speed = 500){
            if (elem == false){
                elem = $('#musicplayer').is('.maximized') ? '#musicplayer' : 'main';
            }

            $(elem).animate({ scrollTop: $(elem).prop("scrollHeight")}, speed);
        },

        escapeHtml(unsafe) {
            return unsafe.replace(/&/g, "&amp;")
                         .replace(/</g, "&lt;")
                         .replace(/>/g, "&gt;")
                         .replace(/"/g, "&quot;")
                         .replace(/'/g, "&#039;");
        }
    },

    computed: {
        getContactsEndpoint() {
            return App.restApi + '/api/v2/conversations/participants?conversable_ids[]=' + this.song.id;
        },

        getMessagesEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/conversation/' + this.selectedContact.conversation_id + '/messages?per_page='+ this.pageSize +'&page='+ this.page;
        },

        postMessagesEndpoint(){
            return App.restApi + '/api/song/' + this.song.id + '/conversation/' + this.selectedContact.conversation_id + '/messages';
        },

        hasContacts() {
            return this.contacts.length > 0;
        },

        showContacts() {
            return this.hasContacts && !this.selectedContact;
        },

        showConversation() {
            return this.selectedContact;
        },

        getContactImage(){
            return this.selectedContact.image ? App.restApi + '/api/image/' + this.selectedContact.image : '/img/web/default-avatar.svg';
        },
    },

    watch: {
        song(){
            // this.echoChannel();
            this.getContacts();
        },

        messages(){
            $.each(this.messages, (i,cm) => {
                var cssClasses = [cm.participant_role]; 
                if (cm.status) cssClasses.push(cm.status);

                if (i > 0){
                    var pm = this.messages[i-1];
                    var pData = moment.utc(cm.created_at).format("DD/MM/YYYY");
                    var cData = moment.utc(cm.created_at).format("DD/MM/YYYY");

                    cm.showDate = pData != cData ? cData : false;
                    cm.showAvatar = pm.participant_role != cm.participant_role ? true : false;
                    cm.sender.image = cm.sender.image != "https://api.soundfeedapp.com/api/image" ? cm.sender.image : "/img/web/default-avatar.svg";

                    if (cm.showAvatar || cm.showDate) cssClasses.push('has-avatar');
                }else{
                    cm.showDate = moment.utc(cm.created_at).format("DD/MM/YYYY");
                    cm.showAvatar = true;
                    cm.sender.image = cm.sender.image != "https://api.soundfeedapp.com/api/image" ? cm.sender.image : "/img/web/default-avatar.svg";

                    if (cm.showAvatar || cm.showDate) cssClasses.push('has-avatar');
                }

                cm.class = cssClasses.join(" ");

                if (!cm.parsed){
                    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
                    //var urlRegex = /(https?:\/\/[^\s]+)/g;
                    cm.text = this.escapeHtml(cm.text).replace(urlRegex, (url,b,c) => {
                        var url2 = (c == 'www.') ? 'http://' +url : url;

                        //image ?
                        if (url2.endsWith(".jpg") || url2.endsWith(".jpeg") || url2.endsWith(".png") || url2.endsWith(".gif")){
                            return `<a data-fancybox="gallery" href="${url2}" target="_self"><img class='preview' src="${url2}"></a>`;
                        }

                        // spotify playlist
                        if (url.indexOf('open.spotify.com') >= 0){
                            if (url.indexOf('/playlist/') >= 0){
                                var spotifyParam = url2.split('/').slice(-1)[0];
                                return `<div class='preview-card'>`+
                                           `<iframe src="https://open.spotify.com/embed?uri=spotify:playlist:${spotifyParam}" width="100%" height="330" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`+
                                           `<div class="btn btn-default button" onclick="navigator.clipboard.writeText('${url}');"><i class="iconify" data-icon="clarity:copy-line"></i></div>`+
                                           `<a href="${url}" target="_blank" class="btn btn-default button">Open in Spotify</a>`+
                                        `</div>`;                        }

                            // spotify album
                            if (url.indexOf('/album/') >= 0){
                                var spotifyParam = url2.split('/').slice(-1)[0];
                                return `<div class='preview-card'>`+
                                           `<iframe src="https://open.spotify.com/embed?uri=spotify:album:${spotifyParam}" width="100%" height="330" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`+
                                           `<div class="btn btn-default button" onclick="navigator.clipboard.writeText('${url}');"><i class="iconify" data-icon="clarity:copy-line"></i></div>`+
                                           `<a href="${url}" target="_blank" class="btn btn-default button">Open in Spotify</a>`+                                           
                                        `</div>`;
                            }
                        }

                        //website ?
                        this.$http.post('https://www.soundfeedapp.com/scripts/url-preview.php', {url: url}, {
                            emulateJSON: true,
                        }).then((success) => {
                            var response = success.data;
                            response.image = response.images && response.images[0] ? response.images[0] : response.image;
                            var html = ``;

                            if (url2.indexOf('uploadapproval.com') != -1){
                                response.image = "https://www.copyright.gov/recordation/images/recordation-full.jpg";
                            }

                            if (url.indexOf('reports.soundfeed.app') * url.indexOf('url.soundfeedapp.com') != 1){
                                response.image = false;
                            }

                            html += `<div class='preview-card'>`;
                                html += response.image ? `<img src="${response.image}">` : `<img src="/img/web/logo-dark.png" style="border: none; width: 70%;">`;
                                html += response.title ? `<h2>${response.title}</h2>` : ``;
                                html += response.description ? `<p>${response.description}</p>` : ``;
                                html += `<div class="btn btn-default button" onclick="navigator.clipboard.writeText('${url2}');"><i class="iconify" data-icon="clarity:copy-line"></i></div>`;
                                html += `<a href="${url2}" target="_blank" class="btn btn-default button">View More</a>`;
                            html += `</div>`;
                            
                            cm.text = cm.text.replace(url, html);
                        }, (error) => {
                            return `<a href="${url2}" target="_blank">${url}</a>`;
                        });

                        return url;
                    })

                    cm.parsed = true;
                }              
            });
        },       

        selectedContact(newContact, oldContact) {
            // leave old channel
            if (oldContact){
                Echo.leave('conversation.' + oldContact.conversation_id);
                $('.messages-list').off('scroll');

                if (App.platform == 'ios'){
                    $('.messages-list').removeAttr('style');
                }
            }

            // Create channel/socket
            if (newContact){
                Echo.private('conversation.' + newContact.conversation_id)
                    .listen('Conversation\\MessageSent', (data) => {
                        var message = data.message;
                        var sameuser = message.sender_id == App.user.id;

                        if (!sameuser || (sameuser && App.status == 'inactive')){
                            message.participant_role = this.getParticipantRole(message.sender_id);
                            this.messages.push(message);
                            if ( $('.messages-list')[0].scrollHeight - $('.messages-list').scrollTop() - $('.messages-list').innerHeight() < 30){
                                this.scrollBottom('.messages-list');
                            }  
                        }
                    });
                
                this.$nextTick(() => {
                    this.page = 0;
                    this.loadingMessages = true;
                    this.getMessages();
                    this.scrollBottom();
                    this.scrollBottom('.messages-list');

                    $('.messages-list').on('scroll', () => {
                        if ( $('.messages-list').scrollTop() < 20 && !this.loadingMessages && !this.allMessagesLoaded){
                            $('.messages-list').animate({scrollTop: 0}, 100);
                            setTimeout(() => {
                                this.loadingMessages = true;
                                this.getMessages(true);
                            })
                        }
                    })
                });
            }
        }
    },

    beforeDestroy() {
        if (this.selectedContact){
            Echo.leave('conversation.' + this.selectedContact.conversation_id);
        }

        $('.messages-list').off('scroll');
        $('body').off('touchstart', "#message-box");
        $(document).off('focusin focusout');        
    }    
}
</script>
